// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_9g-4";
export var collapsed = "_9g-1";
export var headerBar = "_9g-0";
export var leftHeaderContent = "_9g-3";
export var subjectContainer = "_9g-2";